// import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  const slider = document.querySelector(".index-hero__swiper");
  const autoplay = slider.dataset.autoplay === "true" ? true : false;
  const delay = Number(slider.dataset.delay) * 10000;
  const slides = slider.querySelectorAll(".index-hero__slide");
  
  // Wait for images to load before initializing Swiper
  const images = slider.querySelectorAll('img');
  let loadedImages = 0;
  const totalImages = images.length;
  
  function initSwiper() {
    const heroSwiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 600,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      updateOnWindowResize: true,
      autoplay: autoplay && {
        delay: delay,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".index-hero__pagination",
        clickable: true,
        type: "bullets",
        renderBullet: function (index, className) {
          return '<span class="' + className + ' index-hero-bullet">‎</span>';
        },
      },
    });
    
    setupVideoObservers(heroSwiper);
  }
  
  window.addEventListener('third-party-scripts-loaded', initSwiper);
  
  function setupVideoObservers(swiperInstance) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          const isAutoplay = mutation.target.dataset.videoAutoplay;
          const video = whichVideo(mutation.target);
          if (video) {
            if (mutation.target.classList.contains("swiper-slide-active")) {
              if (isAutoplay === "true") {
                video.play();
              }
            } else {
              video.pause();
            }
          }
        }
      });
    });

    const config = { attributes: true, attributeOldValue: true };
    slides.forEach((s, index) => {
      const isVideoDesk = s.querySelector(
        ".index-hero__picture .index-hero__video-desktop"
      );
      const isVideoMob = s.querySelector(
        ".index-hero__picture .index-hero__video-mobile"
      );
      if (isVideoDesk || isVideoMob) {
        observer.observe(s, config);
      }
      if (index === 0 && (isVideoDesk || isVideoMob)) {
        const isAutoplay = s.dataset.videoAutoplay;
        if (isAutoplay === "true") {
          const video = whichVideo(s);
          video.play();
        }
      }
    });
  }

  function whichVideo(slide) {
    const screenWidth = window.innerWidth;
    const desktopVideo = slide.querySelector(
      ".index-hero__video-desktop video"
    );
    const mobileVideo = slide.querySelector(".index-hero__video-mobile video");
    if (mobileVideo && screenWidth < 767) {
      return mobileVideo;
    } else if (desktopVideo) {
      return desktopVideo;
    } else {
      return null;
    }
  }
})();
